// @refresh reset

import loadable, { LoadableComponent } from '@loadable/component';
import React from 'react';

export const VerseSlider = loadable(() => import('./VerseSliderComponent'), {
  resolveComponent: (component: any) => component.VerseSliderComponent,
  fallback: <></>,
}) as LoadableComponent<any>;
